import { buttonBase } from "./layoutStyles";

export const controleChronicPanelStyle = {
    display: "grid",
    gap: "12px",
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #c7d2fe",
    background: "#eef2ff",
    overflowWrap: "anywhere",
};

export const controleChronicHeaderStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "12px",
    flexWrap: "wrap",
};

export const controleChronicTitleStyle = {
    margin: 0,
    color: "#312e81",
    fontSize: "15px",
    fontWeight: 950,
};

export const controleChronicSubtitleStyle = {
    margin: "3px 0 0",
    color: "#64748b",
    fontSize: "12px",
};

export const controleChronicGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: "12px",
};

export const controleChronicColumnStyle = {
    display: "grid",
    alignContent: "start",
    gap: "10px",
    minWidth: 0,
};

export const controleChronicRowsStyle = {
    display: "grid",
    gap: "8px",
};

export const controleChronicRowStyle = {
    display: "grid",
    gridTemplateColumns: "minmax(260px, 2fr) minmax(150px, 0.9fr) minmax(240px, 2fr)",
    gap: "10px",
    alignItems: "start",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #c7d2fe",
    background: "white",
};

export const controleChronicRowActionsStyle = {
    gridColumn: "1 / -1",
    display: "flex",
    justifyContent: "flex-end",
    gap: "7px",
    flexWrap: "wrap",
};

export const controleChronicMetaStyle = {
    display: "block",
    marginTop: "4px",
    color: "#64748b",
    fontSize: "11px",
    lineHeight: 1.35,
};

export const controleChronicReasonFieldStyle = {
    display: "grid",
    gap: "4px",
    color: "#64748b",
    fontSize: "10px",
    fontWeight: 900,
};

export const controleChronicMarkBilledButtonStyle = {
    ...buttonBase,
    padding: "6px 9px",
    minHeight: "33px",
    background: "#f0fdf4",
    borderColor: "#bbf7d0",
    color: "#166534",
    fontWeight: 900,
};

export const controleChronicHistoryButtonStyle = {
    ...buttonBase,
    background: "white",
    borderColor: "#c7d2fe",
    color: "#3730a3",
    fontWeight: 900,
};

export const controleChronicDeleteButtonStyle = {
    ...buttonBase,
    padding: "6px 9px",
    minHeight: "33px",
    background: "#fff1f2",
    borderColor: "#fecdd3",
    color: "#be123c",
    fontWeight: 900,
};

export const controleChronicHistoryRowStyle = {
    display: "grid",
    gap: "4px",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #e0e7ff",
    background: "#f8fafc",
};

export const controleChronicHistoryReasonStyle = {
    color: "#4f46e5",
    fontWeight: 850,
};

export const controleChronicHistoryCommentStyle = {
    color: "#475569",
    lineHeight: 1.4,
    overflowWrap: "anywhere",
};

export const controleChronicModalFormStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
    gap: "10px",
    alignItems: "end",
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #c7d2fe",
    background: "#eef2ff",
};

export const controleChronicProductsPanelStyle = {
    display: "grid",
    gap: "10px",
    minHeight: "160px",
};

export const controleChronicProductsListStyle = {
    display: "grid",
    gap: "8px",
    maxHeight: "440px",
    overflowY: "auto",
    paddingRight: "4px",
};

export const controleChronicProductButtonStyle = (selected, disabled = false) => ({
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
    padding: "10px",
    borderRadius: "8px",
    border: selected ? "1px solid #818cf8" : "1px solid #e0e7ff",
    background: disabled ? "#f8fafc" : selected ? "#e0e7ff" : "white",
    color: disabled ? "#94a3b8" : "#111827",
    textAlign: "left",
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.72 : 1,
});

export const controleChronicProductBadgeStyle = (validated, alreadyInHistory = false) => ({
    flex: "0 0 auto",
    borderRadius: alreadyInHistory ? "6px" : "999px",
    padding: "4px 8px",
    background: alreadyInHistory ? "#e2e8f0" : validated ? "#dcfce7" : "#fee2e2",
    color: alreadyInHistory ? "#475569" : validated ? "#166534" : "#991b1b",
    fontSize: "11px",
    fontWeight: 900,
});

export const controleChronicInlineErrorStyle = {
    color: "#b91c1c",
    fontSize: "12px",
    lineHeight: 1.35,
};

export const controleChronicFieldStyle = {
    display: "grid",
    gap: "5px",
    color: "#312e81",
    fontSize: "12px",
    fontWeight: 900,
    minWidth: 0,
};
